module.exports = __webpack_public_path__ + "img/box-invoice.86428e03.png";